import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import dt from '~/testing';

import TooManyAttemptsContent from './TooManyAttemptsContent';

const dtIds = dt.components.shared.auth.signUpVersionTwo.tooManyAttemptsModal;

type TooManyAttemptsModalProps = {
  isOpen: boolean;
  onContactSupport: () => void;
  onCancel: () => void;
};

export default function TooManyAttemptsModal({
  isOpen,
  onContactSupport,
  onCancel,
}: TooManyAttemptsModalProps) {
  return (
    <Dialog
      type={{ desktop: 'modal', mobile: 'drawer' }}
      isOpen={isOpen}
      dataTestId={dtIds.modal}
    >
      <TooManyAttemptsContent
        onContactSupport={onContactSupport}
        onCancel={onCancel}
      />
    </Dialog>
  );
}
